import { Input } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDebouncedEffect } from "../../hooks/useDebouncedEffect";
import styles from "./_styles.less";
import { useTranslation } from "react-i18next";

function Search({ search, onSearch, loading }, ref) {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState(search ?? "");
  const formatAsDate = (value) => {
    const cleaned = value.replace(/\D/g, "").slice(0, 8);
    const parts = [];

    if (cleaned.length > 0) parts.push(cleaned.substring(0, 2));
    if (cleaned.length > 2) parts.push(cleaned.substring(2, 4));
    if (cleaned.length > 4) parts.push(cleaned.substring(4, 8));

    return parts.join("/");
  };

  const handleChange = (e) => {
    const rawValue = e.target.value;
    const numericOnly = rawValue.replace(/\D/g, "");
    if (/^\d{1,8}$/.test(numericOnly)) {
      const formatted = formatAsDate(rawValue);
      setSearchText(formatted.slice(0, 10));
    } else if (/^\d{2}\/\d{2}\/\d{4}/.test(rawValue)) {
      setSearchText(rawValue.slice(0, 10));
    } else {
      setSearchText(rawValue);
    }
  };

  useDebouncedEffect(
    500,
    () => {
      if (typeof onSearch === "function") onSearch(searchText);
    },
    [searchText],
  );

  return <Input.Search ref={ref} className={styles["search"]} value={searchText} onChange={handleChange} loading={loading} autoFocus />;
}

Search.propTypes = {
  search: PropTypes.string,
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
};

export default React.forwardRef(Search);
